import React from "react";
import ModalBasic from "./ModalBasic";
import { FaCircleInfo, FaCircleExclamation } from "react-icons/fa6";

const DemoEnvironmentModal = ({ isOpen, onClose }) => {
  return (
    <ModalBasic
      modalOpen={isOpen}
      setModalOpen={onClose}
      title="Demo Environment"
      width="md"
      hideCloseButton={false}
    >
      <div className="space-y-4">
        <div className="flex items-center gap-3 p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg">
          <FaCircleExclamation className="w-6 h-6 text-yellow-600 dark:text-yellow-400 flex-shrink-0" />
          <p className="text-sm text-yellow-800 dark:text-yellow-200 font-medium">
            You are in demo mode
          </p>
        </div>

        <div className="space-y-3">
          <p className="text-slate-600 dark:text-slate-400">
            You are currently logged in as a demo user. Please note:
          </p>
          
          <ul className="space-y-2 pl-6">
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-400">
              <span className="text-red-500 mt-1">•</span>
              <span>No data or actions will be persisted</span>
            </li>
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-400">
              <span className="text-red-500 mt-1">•</span>
              <span>Any changes you make will be reset on page refresh</span>
            </li>
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-400">
              <span className="text-red-500 mt-1">•</span>
              <span>This is connected to the development environment</span>
            </li>
          </ul>
        </div>

        <div className="flex items-center gap-2 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg mt-4">
          <FaCircleInfo className="w-5 h-5 text-blue-600 dark:text-blue-400 flex-shrink-0" />
          <p className="text-sm text-blue-800 dark:text-blue-200">
            For full functionality with data persistence, please log in with a regular account.
          </p>
        </div>
      </div>
    </ModalBasic>
  );
};

export default DemoEnvironmentModal;
